import React, { useEffect, useState } from "react";
import "./ddd.css";

/** Company / org header only — never the in-game Truth & Tricks artwork. */
function resolveCompanyHeaderUrl(propUrl) {
  if (propUrl && String(propUrl).trim()) return String(propUrl).trim();
  try {
    const ud = JSON.parse(sessionStorage.getItem("userData") || "null");
    const c = ud?.companyLogoUrl;
    if (typeof c === "string" && c.trim()) return c.trim();
  } catch {
    /* ignore */
  }
  const org = sessionStorage.getItem("orgData");
  if (org && String(org).trim()) return String(org).trim();
  const em = process.env.REACT_APP_EM_LOGO;
  if (em && String(em).trim()) return String(em).trim();
  return "";
}

function DDDUI({ imageUrl, onBack, children, showBackButton = true }) {
  const emLogo = (process.env.REACT_APP_EM_LOGO || "").trim();
  const location = window.location;
  const baseUrl = (process.env.REACT_APP_BASE_URL || "").trim();
  const user = (() => {
    try {
      return JSON.parse(sessionStorage.getItem("userData") || "null");
    } catch {
      return null;
    }
  })();
  const [headerSrc, setHeaderSrc] = useState(() => resolveCompanyHeaderUrl(imageUrl));
  const [triedEmFallback, setTriedEmFallback] = useState(false);
  const fromMobileAppInUrl =
    String(new URLSearchParams(location.search).get("fromMobileApp") || "").toLowerCase() ===
    "true";
  const fromMobileAppInUser = String(user?.fromMobileApp || "").toLowerCase() === "true";
  const persistedFromMobileApp = (() => {
    try {
      const persistedFlag = sessionStorage.getItem("fromMobileApp");
      if (String(persistedFlag || "").toLowerCase() === "true") {
        return true;
      }
      const persisted = JSON.parse(sessionStorage.getItem("userData") || "{}");
      return String(persisted?.fromMobileApp || "").toLowerCase() === "true";
    } catch {
      return false;
    }
  })();
  const isFromMobileApp = fromMobileAppInUrl || fromMobileAppInUser || persistedFromMobileApp;
  const shouldShowBackButton = showBackButton && !isFromMobileApp;
  const logoHref = baseUrl || "/";

  useEffect(() => {
    setHeaderSrc(resolveCompanyHeaderUrl(imageUrl));
    setTriedEmFallback(false);
  }, [imageUrl]);

  useEffect(() => {
    if (!fromMobileAppInUrl && !fromMobileAppInUser) return;
    try {
      sessionStorage.setItem("fromMobileApp", "true");
    } catch {
      // Ignore storage errors in restricted environments.
    }
  }, [fromMobileAppInUrl, fromMobileAppInUser]);

  const handleImgError = () => {
    if (!triedEmFallback && emLogo && headerSrc !== emLogo) {
      setTriedEmFallback(true);
      setHeaderSrc(emLogo);
      return;
    }
    setHeaderSrc("");
  };

  const handleLogoClick = (e) => {
    if (!isFromMobileApp) return;
    e.preventDefault();
    window.GameStatus?.postMessage?.("navigate_back");
  };


  return (
    <>
      <header className="upperaction">
        <a href={process.env.REACT_APP_BASE_URL} onClick={handleLogoClick}>
          {headerSrc ? (
            <img src={headerSrc} alt="" className="logo-holder" onError={handleImgError} />
          ) : (
            <span className="logo-holder logo-holder--empty" aria-hidden />
          )}
        </a>
        {shouldShowBackButton ? (
          <div className="back-holder">
            <button type="button" onClick={onBack} className="back-default">
              Back
            </button>
          </div>
        ) : null}
      </header>
      {children}
    </>
  );
}

export default DDDUI;